import { render, staticRenderFns } from "./ViewBoxModal.vue?vue&type=template&id=4bad9297&lang=pug&"
import script from "./ViewBoxModal.vue?vue&type=script&lang=js&"
export * from "./ViewBoxModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports